import { ALL_TRACKERS } from './constants';
import createGaProxy from './createGaProxy';

const gaAll = createGaProxy(ALL_TRACKERS);

class GoogleAnalyticsAgent {
  constructor() {
    this.initialized = false;
  }

  initialize() {
    this.initialized = true;
  }

  recordEvent(category, action, label, value) {
    if (!this.initialized) return;

    gaAll('send', 'event', category, action, label, value);
  }
}

export default new GoogleAnalyticsAgent();
